import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@mui/material";

import { ThemeProviderWrapper } from "./context/ThemeContext";
import { ViewModeProvider } from "./context/ViewModeContext";

import "./index.css";

import { AuthProvider } from "./context/AuthContext";
import { SnackbarProvider } from "notistack";
import { MainRoute } from "./Route";
import { useLocation } from "react-router-dom";

const AppContent = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 1 });
  }, [location]);
  return (
    <AuthProvider>
      <MainRoute />
    </AuthProvider>
  );
};

const App = () => {
  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
    return () => {
      window.removeEventListener("resize", appHeight);
    };
  }, []);

  return (
    <ThemeProviderWrapper>
      <ViewModeProvider>
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          autoHideDuration={1500}
        >
          <Router>
            <CssBaseline />
            <AppContent />
          </Router>
        </SnackbarProvider>
      </ViewModeProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
